import React, { useEffect, useRef } from "react";
import Typewriter from "typewriter-effect";

interface TypedTextProps {
    index?:any;
  text: string;
  delay?: number; // typing speed
  cursor?: any; // cursor symbol
}

const TypedText: React.FC<TypedTextProps> = ({
 index ,
    text,
  delay = 60,
}) => {
  const hasTyped = useRef(false);

  // Show plain text if already typed
  if (hasTyped.current) {
    return <span>{text}</span>;
  }

const cleanHtml = (html = "") =>
  html
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .replace(/&amp;/g, "&")
    .trim();
const decodeHTML = (str = "") => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
 
  return txt.value.replace(/&amp;/g, "&");
};

// const decodeHTML = (html: string = "") => {
//   const txt = document.createElement("textarea");

//   let decoded = html;
//   let prev = "";

//   // 🔁 keep decoding until fully clean (handles &amp;amp;)
//   while (decoded !== prev) {
//     prev = decoded;
//     txt.innerHTML = decoded;
//     decoded = txt.value;
//   }

//   return decoded;
// };

// const cleanHtml = (html = "") => {
//   return decodeHTML(html)
//     .replace(/<[^>]*>/g, "") // remove HTML tags if any
//     .replace(/\s+/g, " ")
//     .replace(/&amp;/g, "&")
//     .trim();
// };
const cleanHtmls = (html: string = "") => {
  const txt = document.createElement("textarea");

  let decoded = html;
  let prev = "";

  // ✅ Step 1: fully decode (&amp;, &amp;amp;, etc.)
  while (decoded !== prev) {
    prev = decoded;
    txt.innerHTML = decoded;
    decoded = txt.value;
  }

  // ✅ Step 2: remove HTML tags
  decoded = decoded.replace(/<\/?[^>]+(>|$)/g, "");

  // ✅ Step 3: fix spacing
  return decoded.replace(/\s+/g, " ").trim();
};
  return (
    <>
     {/* <Typewriter
      key={index}
      onInit={(typewriter: any) => {
        hasTyped.current = true;
        typewriter.typeString(text).start();
      }}
      options={{
        autoStart: true,
        delay: delay,
        cursor: "",
      }}
    /> */}
     <Typewriter
            key={index}
            onInit={(typewriter: any) => {
            typewriter
                .deleteAll(1) // 🔥 removes previous text instantly
                .typeString(cleanHtml(text))
                
                .start();
            }}
            options={{
            delay: 100, // slow typing
            cursor: "",
            }}
        />
    </>
   
  );
};

export default TypedText;
